export default __webpack_public_path__ + "static/taskdefinition15-3b586951ac1b93b06b68fc2fb84f351d.png";